import React, { useEffect, useState } from 'react';
export function MobilePopup({
  onClose
}: {
  onClose: () => void;
}) {
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/1BfG5o9hUPR1QrMjxJQM5M/Image_800x800.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/ntK1XQFxqjK4NWrjhDQwYL/Image_1000x1000_%281%29.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/8QczgcL9ty8Bv8Zk8NXN5c/Image_1000x1000_%282%29.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/fFhVzbyTM7m4mnHxg8vvSd/Image_800x800_%281%29.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/dSDXr6KSfwg8qPhswdh8xc/Capture-2025-06-27-030702.png'];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % images.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [images.length]);
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50" data-id="element-154">
      <div className="relative w-full max-w-sm bg-white rounded-lg shadow-xl border border-gray-200 p-4 max-h-[90vh] overflow-y-auto" data-id="element-155">
        <button onClick={onClose} className="absolute top-2 right-2 w-8 h-8 flex items-center justify-center bg-gray-200 rounded-full text-gray-600 hover:bg-gray-300" data-id="element-156">
          ✕
        </button>
        <h3 className="text-2xl font-bold text-center mb-1 mt-2" data-id="element-157">
          Recommended:
        </h3>
        <div className="flex justify-center mb-1" data-id="element-158">
          {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-6 h-6 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-159">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-160" />
            </svg>)}
        </div>
        <p className="text-lg text-center mb-2" data-id="element-161">4.9 | 3,788 Reviews</p>
        <div className="text-center mb-1" data-id="element-162">
          <span className="text-2xl font-bold" data-id="element-163">The Nice Shoes</span>
        </div>
        <p className="text-sm text-center text-gray-700 mb-2" data-id="element-164">
          Barefoot Day-to-Day, Running, and Hiking Shoes
        </p>
        <div className="flex justify-center mb-4 h-40 overflow-hidden" data-id="element-165">
          <img src={images[currentImageIndex]} alt={`The Nice Shoes - Style ${currentImageIndex + 1}`} className="w-auto h-full object-contain" data-id="element-166" />
        </div>
        <ul className="space-y-2 mb-4 text-base" data-id="element-167">
          <li className="flex items-start" data-id="element-168">
            <div className="flex-shrink-0 w-6 h-6 bg-green-700 rounded-full flex items-center justify-center mr-2" data-id="element-169">
              <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20" data-id="element-170">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-171" />
              </svg>
            </div>
            <span data-id="element-172">Helps reduce Foot Pain & Inflammation</span>
          </li>
          <li className="flex items-start" data-id="element-173">
            <div className="flex-shrink-0 w-6 h-6 bg-green-700 rounded-full flex items-center justify-center mr-2" data-id="element-174">
              <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20" data-id="element-175">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-176" />
              </svg>
            </div>
            <span data-id="element-177">
              Helps relieve Your Foot & Arch Pain From Plantar Fasciitis
            </span>
          </li>
          <li className="flex items-start" data-id="element-178">
            <div className="flex-shrink-0 w-6 h-6 bg-green-700 rounded-full flex items-center justify-center mr-2" data-id="element-179">
              <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20" data-id="element-180">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-181" />
              </svg>
            </div>
            <span data-id="element-182">Walk or Work Up To 12 Hours With No Trouble</span>
          </li>
          <li className="flex items-start" data-id="element-183">
            <div className="flex-shrink-0 w-6 h-6 bg-green-700 rounded-full flex items-center justify-center mr-2" data-id="element-184">
              <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20" data-id="element-185">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-186" />
              </svg>
            </div>
            <span data-id="element-187">
              Light as Air with Cushioned Footbed — For warm days, long walks,
              and everyday movement.
            </span>
          </li>
        </ul>
        <a href="https://www.theniceshoes.store/" className="w-full bg-green-700 hover:bg-green-800 text-white font-bold py-3 px-3 rounded-lg text-lg flex items-center justify-center transition-all cursor-pointer" data-id="element-188">
          Check Availability
          <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-189">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-190" />
          </svg>
        </a>
      </div>
    </div>;
}